import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'readableDate',
    pure: true,
    standalone: false
})
export class ReadableDatePipe implements PipeTransform {
  /**
   * @param value the date to format
   * @param dateOnly drop the time and render just "Jul 31st, 2026". Defaults to false, so
   *                 every existing caller keeps the full date-and-time output unchanged.
   * @returns the formatted date, or '-' when there is nothing to format
   */
  transform(value: Date | string | number | null | undefined, dateOnly = false): string {
    if (!value) {
      return '-';
    }

    const date = new Date(value);
    if (isNaN(date.getTime())) {
      return '-';
    }

    const day = date.getDate();
    const paddedDay = day.toString().padStart(2, '0');
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear();

    if (dateOnly) {
      return `${month} ${paddedDay}${this.getDaySuffix(day)}, ${year}`;
    }

    const hours12 = date.getHours() % 12 || 12;
    const paddedHours = hours12.toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    const ampm = date.getHours() >= 12 ? 'PM' : 'AM';

    const suffix = this.getDaySuffix(day);

    return `${month} ${paddedDay}${suffix}, ${year} ${paddedHours}:${minutes}:${seconds} ${ampm}`;
  }

  private getDaySuffix(day: number): string {
    if (day >= 11 && day <= 13) {
      return 'th';
    }

    switch (day % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  }
}
